export default {
  completeAt: "Complete at",
  createdAt: "Created at",
  debitCredit: "Debit credit",
  documentNumber: "Document number",
  id: "Id",
  kontragentAccount: "Kontragent account",
  kontragentBankName: "Kontragent bank name",
  kontragentEgrpou: "Kontragent EGRPOU",
  kontragentMfo: "Kontragent MFO",
  kontragentName: "Kontragent name",
  mainDocumentCode: "Main document code",
  mainDocumentName: "Main document name",
  paymentPurpose: "Payment purpose",
  subDocumentCode: "Sub document code",
  subDocumentName: "Sub document mame",
  sum: "Sum",
  sumEquivalent: "Sum equivalent",
  paymentType: "Payment type",
  transactionType: "Transaction type",
  statementFullReference: "Statement full reference",
  transactionReference: "Transaction reference",
  statementNumber: "Statement number",
  transactionRealityType: "Transaction reality type",
  paymentDocumentType: "Payment document type",
  paymentDocumentNumber: "Payment document number",
  currencyExchangeDate: "Currency exchange date",
  transactionTime: "Transaction time",
  amount: "Amount",
  currency: "Currency",
  beneficiaryAccount: "Beneficiary account",
  beneficiaryName: "Beneficiary Name",
  beneficiaryUSREOU: "Beneficiary USREOU",
  beneficiaryMFO: "Beneficiary MFO",
  addressantAccount: "Addressant account",
  addressantUSREOU: "Addressant USREOU",
  addressantName: "Addressant name",
  addressantMFO: "Addressant MFO",
  addressantMFOName: "Addressant MFO name",
  addressantMFOCity: "Addressant MFO city",
  beneficiaryMFOName: "Beneficiary MFO name",
  beneficiaryMFOCity: "Beneficiary MFO city",
  reasonForPayment: "Reason for payment",
  transactionStatus: "Transaction status",
  clientDate: "Client date",
  addressantCorrespondentAccount: "Addressant corresponedent account",
  beneficiaryCorrespondentAccount: "Beneficiary correspondent account",
  paymentService: "Payment service",
  paymentServiceTransactionReference: "Payment service transaction reference",
  paymentClass: "Payment class",
  amountInNationalCurrency: "Amount in national currency",
  movementType: "Movement type",
  movementSubType: "Movement sub type",
  bank: "Bank",
  balanceAfterOperation: "Balance after operation",
  transactionId: "Transaction id",
  transactionIdString: "Transaction id string",
  beneficiaryPaymentCategory: "Beneficiary payment category",
  cusClientId: "Cus client id",
  dealType: "Deal type",
  myBeneficiaryAccount: "My beneficiary account",
  myBeneficiaryName: "My beneficiary name",
  myBeneficiaryUSREOU: "My beneficiary USREOU",
  myBeneficiaryMFO: "My beneficiary MFO",
  myAddressantMFOName: "My addressant MFO name",
  myAddressantMFOCity: "My addressant MFO city",
  myCorrespondentAccount: "My correspondent account",
  contractPartnerAccount: "Contract partner account",
  contractPartnerName: "Contract partner name",
  contractPartnerUSREOU: "Contract partner USREOU",
  contractPartnerMFO: "Contract partner MFO",
  contractPartnerMFOName: "Contract partner MFO name",
  contractPartnerMFOCity: "Contract partner city",
  contractPartnerCorrespondentAccount: "Contract partner correspondent account",
  transactionDateTime: "Transaction date time",
};
